import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Meta Pixel Code — inyección única
const pixelScript = document.createElement('script');
pixelScript.textContent = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','956984870346481');fbq('track','PageView');`;
document.head.appendChild(pixelScript);
const ns = document.createElement('noscript');
ns.innerHTML = '<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=956984870346481&ev=PageView&noscript=1" />';
document.head.appendChild(ns);
render(<App data-id="element-284" />, document.getElementById('root'));